import React, { createContext, useContext, useEffect, useState } from 'react';

const translations = {
  "O'zbekcha": {
    menu: { dashboard: "Asosiy oyna", projects: "Loyihalar", analytics: "Doskalar", calendar: "Kalendar", admin: "Admin Panel", contact: "Qo'llab quvatlash", settings: "Sozlamalar", search: "Qidirish" },
    dashboard: {
      welcome: "Xush kelibsiz, SMM Menejer!",
      subtitle: "Bugungi ish rejangiz va umumiy statistika bilan tanishing.",
      platformActivity: "Platformalar faolligi (Rejadagi postlar)",
      cards: { activeProjects: "Faol Loyihalar", todayPosts: "Bugungi Postlar", published: "Chop etilganlar", pending: "Kutilayotganlar" },
      upcoming: { title: "Yaqin kunlardagi postlar", empty: "Yaqin kunlar uchun postlar rejalashtirilmagan.", todayLabel: "Bugun" }
    },
    projectList: {
      title: "SMM CRM Paneli", archive: "Arxiv", todayPlan: "Bugungi kontentlar rejasi",
      noToday: "Bugun uchun faol kontent rejalashtirilmagan.", activeProjects: "Faol Loyihalar",
      addProject: "Loyiha", noActive: "Hozircha faol loyihalar yo'q.",
      actions: { edit: "Tahrirlash", archive: "Arxivlash" },
      buttons: { cancel: "Bekor qilish", save: "Saqlash", exportPdf: "PDF", addContent: "Kontent", restore: "Tiklash", delete: "O'chirish" },
      modalTitles: { addProject: "Yangi loyiha", editProject: "Loyihani tahrirlash", addContent: "Yangi kontent qo'shish", editContent: "Kontentni tahrirlash" },
      labels: {
        budget: "Byujet", phone: "Tel", activeContentCount: "{count} ta faol kontent",
        plannedContentList: "Rejalashtirilgan kontentlar ro'yxati",
        projectNotSelected: "Loyiha tanlanmagan yoki loyiha ochilmagan.",
        archiveTitle: "Arxiv bazasi", totalContent: "Jami kontent: {count}",
        noActiveContent: "Faol kontentlar yo'q.", archiveEmptyProjects: "Loyihalar arxivi bo'sh.", archiveEmptyContents: "Kontentlar arxivi bo'sh."
      },
      archiveTabs: { projects: "Loyihalar", contents: "Kontent rejalari" },
      confirmations: { deleteTitle: "O'chirishni tasdiqlang" },
      statuses: { pending: "Kutilmoqda", published: "Chop etildi", cancelled: "Rad etildi", moved: "Ko'chirildi" },
      formats: { reels: "Reels", carousel: "Karusel", post: "Post", animation: "Animatsiya", story: "AI kontent" },
      pdf: { brand: "Brend:", phone: "Raqam:", fullName: "F.I.O:", contentPlan: "KONTENT PLAN", date: "Sana:", empty: "Hozircha rejalashtirilgan kontentlar mavjud emas.", filenameSuffix: "Kontent_Reja" },
      alerts: { fillAll: "Ma'lumotlarni to'liq kiriting!", titleDateRequired: "Sarlavha va sanani kiriting!", selectPlatform: "Kamida bitta platformani tanlang!" },
      placeholders: { projectName: "Loyiha nomi", phone: "Telefon raqami", budget: "Target byujeti ($)", contentTitle: "Sarlavha", contentIdea: "Kontent ideyasi" },
      notifications: {
        projectAdded: '"{name}" loyihasi qo\'shildi!', projectEdited: "Loyiha tahrirlandi!",
        projectArchived: '"{name}" arxivlandi!', projectRestored: "Loyiha arxivdan tiklandi!", projectDeleted: "Arxivlangan loyiha va uning kontentlari o'chirildi!", confirmDeleteProject: '"{name}" loyihasini va undagi barcha kontentlarni butunlay o\'chirmoqchimisiz?',
        contentAdded: "Yangi kontent qo'shildi!", contentArchived: "Kontent arxivlandi!",
        contentRestored: "Kontent arxivdan tiklandi!", contentDeleted: "Arxivlangan kontent reja o'chirildi!", confirmDeleteContent: '"{name}" kontent rejasini butunlay o\'chirmoqchimisiz?', contentEdited: "Kontent tahrirlandi!",
        statusChanged: "{platform} holati o'zgardi!", pdfDownloaded: '"{name}" PDF yuklab olindi!'
      }
    },
    login: {
      title: "SMM CRM", subtitle: "Tizimga kirish", emailPlaceholder: "Email kiriting",
      passwordPlaceholder: "Parol", submit: "Kirish",
      footer: "Barcha ma'lumotlar SMM CRM tizimi orqali xavfsiz himoyalanadi!",
      invalidCredentials: "Email yoki parol noto'g'ri!"
    },
    analytics: {
      pickBoard: "Bo'limni tanlang",
      back: "Orqaga",
      templates: "Shablonlar",
      archives: "Arxivlar",
      addCard: "Kartochka qo'shish",
      insertLink: "Havola qo'shish",
      addList: "Ro'yxat qo'shish",
      board: "DOSKASI",
      boards: { dizayn: "DIZAYN", montaj: "MONTAJ", vfxAi: "VFX & AI" },
      archiveAllCards: "Barcha kartochkalarni arxivlash",
      archiveColumn: "Ro'yxatni arxivlash",
      columnActions: "Ro'yxat amallari",
      changeColumnColor: "Ro'yxat rangini o'zgartirish",
      archiveTask: "Kartochkani arxivlash",
      makeTemplate: "Shablon sifatida saqlash",
      templateListTitle: "Shablonlar ro'yxati",
      noTemplates: "Hali shablonlar yo'q",
      newTemplatePlaceholder: "Yangi shablon...",
      createNewTemplate: "+ Yangi shablon yaratish",
      cardsTab: "Kartochkalar",
      columnsTab: "Ustunlar",
      noArchiveCards: "Arxivda kartochka yo'q",
      noArchiveColumns: "Arxivda ustun yo'q",
      restore: "Tiklash",
      column: "Ustun",
      list: "Ro'yxat",
      tasksCount: "vazifa",
      deleteTemplateConfirmTitle: "Shablonni o'chirish",
      deleteTemplateConfirmMessage: "Haqiqatan ham {name} shablonini o'chirmoqchimisiz?",
      cardDeleteConfirmTitle: "Kartochkani o'chirish",
      cardDeleteConfirmMessage: "Haqiqatan ham bu kartochkani o'chirmoqchimisiz?",
      columnDeleteConfirmTitle: "Ustunni o'chirish",
      columnDeleteConfirmMessage: "Haqiqatan ham bu ustunni o'chirmoqchimisiz?",
      newColumnPlaceholder: "Ro'yxat nomi...",
      add: "Qo'shish",
      editColumnHint: "Tahrirlash uchun ikki marta bosing",
      labels: { dates: "Muddat", participants: "Mutaxasislar", boardParticipants: "Doska mutaxasislari", description: "Ta'rif", commentsEvents: "Izohlar va voqealar", archiveTask: "Kartochkani arxivlash" },
      buttons: { save: "Saqlash", cancel: "Bekor qilish", send: "Yuborish", confirm: "Tasdiqlash", delete: "O'chirish" },
      tooltips: { doubleClickHint: "O'zgartirish uchun 2 marta bosing" },
      toast: {
        columnReordered: "Ustun tartibi yangilandi",
        templateDeleted: "Shablon o'chirildi",
        cardDeleted: "Kartochka o'chirildi",
        columnDeleted: "Ustun o'chirildi",
        templateSaved: "Shablon saqlandi",
        templateCreated: "Shablon yaratildi",
        templateApplied: "Shablon qo'llanildi",
        templateAppliedHistory: "Shablon orqali qo'shildi",
        columnRestored: "Ustun tiklandi",
        taskMoved: "Vazifa ko'chirildi",
        restoreSuccess: "Arxivdan tiklandi"
      },
      messages: {
        duplicateColumnTitle: "Xatolik",
        duplicateColumnMessage: "Bu nomdagi ustun allaqachon mavjud!",
        newColumnAdded: "Yangi ustun qo'shildi",
        columnRenamed: "Ustun nomi o'zgardi",
        newTaskTitle: "Yangi vazifa",
        newTaskPlaceholder: "Vazifa nomini kiriting...",
        taskAdded: "Yangi vazifa qo'shildi!",
        taskRenamed: "Nom o'zgartirildi",
        titleUpdated: "Sarlavha yangilandi",
        descriptionSaved: "Ta'rif saqlandi",
        statusChanged: "Status o'zgardi",
        membersUpdated: "Mutaxasislar yangilandi",
        deadlineRemoved: "Muddat olib tashlandi",
        deadlineSaved: "Muddat saqlandi",
        linkUrlPrompt: "Link URL manzilini kiriting (masalan: https://google.com):",
        invalidLink: "To'g'ri URL manzilini kiriting.",
        archiveCardConfirmTitle: "Kartochkani arxivlash",
        archiveCardConfirmMessage: "Haqiqatan ham \"{name}\" arxivga o'tkazilsinmi?",
        archiveColumnConfirmTitle: "Ustunni arxivlash",
        archiveColumnConfirmMessage: "\"{name}\" ustunini barcha vazifalari bilan arxivga o'tkazmoqchimisiz?",
        cardArchived: "Vazifa arxivlandi",
        noCardsToArchiveTitle: "Diqqat",
        noCardsToArchiveMessage: "Bu ustunda arxivlash uchun kartochka yo'q!",
        archiveAllCardsConfirmTitle: "Barcha kartochkalarni arxivlash",
        archiveAllCardsConfirmMessage: "\"{name}\" ustunidagi BARCHA kartochkalarni arxivga o'tkazmoqchimisiz?",
        allTasksArchived: "Barcha vazifalar arxivlandi",
        deadlineDatePlaceholder: "DD.MM.YYYY",
        deadlineTimePlaceholder: "12:00",
        searchPlaceholder: "Qidirish...",
        descriptionPlaceholder: "Batafsil ta'rif qo'shing...",
        commentPlaceholder: "Izoh yozing..."
      },
      weekDays: ["Dsh", "Ssh", "Chr", "Pay", "Jum", "Sha", "Yak"]
    },
    boardDetails: { back: "Orqaga", board: "DOSKASI", addTask: "Yangi vazifa qo'shish", newTaskPrompt: "Vazifa nomini kiriting:", confirmDeleteTask: "Bu vazifani o'chirmoqchimisiz?" },
    logout: "Chiqish",
    admin: {
      title: "Admin Panel",
      subtitle: "Foydalanuvchilarni boshqaring va yangilarini qo'shing",
      addUser: "Yangi foydalanuvchi",
      addUserSub: "Ma'lumotlarni to'ldiring va qo'shing",
      userList: "Foydalanuvchilar ro'yxati",
      totalUsers: "Jami",
      thisMonth: "Bu oy",
      name: "Ism Familiya",
      email: "Email",
      role: "Mutaxasisligi",
      password: "Parol",
      pwdPlaceholder: "Parolni kiriting...",
      randomBtn: "Tasodifiy",
      addBtn: "Qo'shish",
      selectRole: "Mutaxasislikni tanlang",
      customRole: "O'z mutaxasisligini kiriting...",
      addedDate: "Qo'shilgan",
      sendEmail: "Email yuborish",
      viewCredentials: "Ma'lumotlarni ko'rish",
      deleteUser: "O'chirish",
      noUsers: "Hali foydalanuvchilar qo'shilmagan",
      noResults: "Qidiruv bo'yicha natija topilmadi",
      credentialsTitle: "Login ma'lumotlari tayyor!",
      credentialsSub: "Quyidagi ma'lumotlarni foydalanuvchiga yuboring",
      copy: "Nusxa olish",
      copied: "Nusxalandi!",
      closeBtn: "Yopish",
      deleteTitle: "Foydalanuvchini o'chirish",
      deleteBody: "foydalanuvchisini o'chirmoqchimisiz?",
      cancelBtn: "Bekor qilish",
      deleteBtn: "O'chirish",
      fillAll: "Barcha maydonlarni to'ldiring!",
      invalidEmail: "Email manzili noto'g'ri!",
      emailExists: "Bu email allaqachon mavjud!",
      userAdded: "Foydalanuvchi qo'shildi!",
      userDeleted: "Foydalanuvchi o'chirildi"
    },
    settings: {
      centerLabel: "Sozlamalar markazi",
      title: "Sayt sozlanmalari",
      subtitle: "Til, profil va sayt dizayni bo'limlarini shu yerda boshqarasiz.",
      tabs: { language: "Tilni o'zgartirish", profile: "Profil", design: "Sayt dizayni", security: "Xavfsizlik" },
      languageTitle: "Tilni o'zgartirish",
      languageDescription: "Interfeys tilini bir necha soniya ichida yangilang.",
      profileTitle: "Profil",
      profileDescription: "Shaxsiy ma'lumotlaringizni tezda yangilang.",
      designTitle: "Sayt dizayni",
      designDescription: "Tungi yoki yorug' rejim, hamda sayt rangini tanlang.",
      securityTitle: "Xavfsizlik",
      securityDescription: "Hisobingizni xavfsiz saqlash uchun sozlamalarni yangilang.",
      buttons: { save: "Saqlash", themeDark: "Tungi rejimga o'tkazish", themeLight: "Yorug' rejimga o'tkazish", passwordUpdate: "Parolni yangilash", twoFactorOn: "2FA yoqish", twoFactorOff: "2FA o'chirish" },
      colors: { blue: "Ko'k", purple: "Binafsha", green: "Yashil", orange: "To'q sariq" },
      labels: { fullName: "To'liq ism", email: "Email", status: "Status", currentPassword: "Joriy parol", newPassword: "Yangi parol", confirmPassword: "Yangi parolni tasdiqlash", selectedLanguage: "Tanlangan til", accentColor: "Accent rangi", activeWindow: "Faol oyna", currentRules: "Joriy qoidalar" },
      statusActive: { enabled: "2FA yoqilgan", disabled: "2FA o'chirilgan" },
      activity: { language: "Til sozlamalari orqali muloqotni yanada qulayroq qiling.", profile: "Profil bo'limida shaxsiy ma'lumotlaringizni yangilang.", design: "Sayt dizayni bo'limida ko'rinish va ranglarni o'zgartiring.", security: "Xavfsizlik bo'limida hisobingizni yanada ishonchli qiling." },
      profileCard: "Shaxsiy profil",
      messages: { fillRequired: "Ism va email maydonlari to'ldirilishi shart.", profileSaved: "Profil ma'lumotlari muvaffaqiyatli saqlandi.", siteColorChanged: "Saytning asosiy rangi {color} ga o'zgardi.", themeChanged: "Tema {mode} rejimga o'zgartirildi.", passwordRequired: "Barcha parol maydonlarini to'ldiring.", passwordMismatch: "Yangi parol va tasdiqlash mos emas.", passwordShort: "Yangi parol kamida 6 ta belgidan iborat bo'lishi kerak.", passwordUpdated: "Parol muvaffaqiyatli yangilandi.", twoFactorEnabled: "Ikki faktorli autentifikatsiya yoqildi.", twoFactorDisabled: "Ikki faktorli autentifikatsiya o'chirildi." },
      confirm: { title: "Tilni o'zgartirishni tasdiqlaysizmi?", body: "Haqiqatan ham sayt tilini o'zgartirmoqchimisiz? Sayt qayta yuklanadi va yangi til qo'llaniladi.", yes: "Ha", no: "Yo'q" },
      langTab: "Til sozlamalari", profileTab: "Profil ma'lumotlari", designTab: "Dizayn", securityTab: "Xavfsizlik",
      avatarTitle: "Profil rasmi", avatarDesc: "JPG, PNG yoki GIF — max 5MB", avatarUpload: "Rasm yuklash", avatarDelete: "O'chirish",
      themeTitle: "Mavzu", themeLight: "Yorug'", themeDark: "Qorong'u", themeActive: "Faol", accentTitle: "Asosiy rang",
      saveLanguage: "Tilni saqlash", saveProfile: "Ma'lumotlarni saqlash", cancelBtn: "Bekor qilish", confirmBtn: "Tasdiqlash",
      langModalTitle: "Tilni o'zgartirishni tasdiqlaysizmi?", langModalBody: "Sayt tili {lang} ga o'zgartiriladi va sahifa qayta yuklanadi.",
      pwdPlaceholder: "Kamida 6 ta belgi", pwdStrength: ["Juda zaif", "Zaif", "O'rtacha", "Kuchli", "Juda kuchli"],
      pwdMatch: "Parollar mos keldi", pwdNoMatch: "Parollar mos kelmadi",
      toastProfileSaved: "Profil ma'lumotlari saqlandi ✓", toastFieldsRequired: "Ism va email bo'sh bo'lmasin!",
      toastPwdRequired: "Barcha parol maydonlarini to'ldiring!", toastPwdError: "Joriy parol noto'g'ri!",
      toastPwdMismatch: "Yangi parollar mos kelmadi!", toastPwdShort: "Parol kamida 6 ta belgi bo'lishi kerak!",
      toastPwdUpdated: "Parol muvaffaqiyatli yangilandi ✓", toastThemeChanged: "Mavzu o'zgartirildi ✓", toastColorChanged: "Rang o'zgartirildi ✓"
    },
    calendar: {
      title: "Kontent Kalendarı",
      subtitle: "Barcha rejalar bir ko'rinishda",
      months: ["Yanvar","Fevral","Mart","Aprel","May","Iyun","Iyul","Avgust","Sentabr","Oktabr","Noyabr","Dekabr"],
      weekDays: ["Du","Se","Ch","Pa","Ju","Sh","Ya"],
      today: "Bugun",
      noPostsDay: "Bu kun uchun kontent yo'q",
      moreItems: "+{n} ta yana",
      postsFor: "Kontent rejasi",
      totalThisMonth: "Bu oy jami",
      publishedThisMonth: "Chop etilganlar"
    },
    search: {
      placeholder: "Qidirish: loyiha, kontent, kartochka...",
      noResults: "Hech narsa topilmadi",
      typing: "Qidiruv uchun yozing...",
      projects: "Loyihalar",
      contents: "Kontentlar",
      cards: "Kartochkalar"
    }
  },
  "Русский": {
    menu: { dashboard: "Главная", projects: "Проекты", analytics: "Доски", calendar: "Календарь", admin: "Админ Панель", contact: "Связаться", settings: "Настройки", search: "Поиск" },
    dashboard: {
      welcome: "Добро пожаловать, SMM Менеджер!",
      subtitle: "Ознакомьтесь с планом на сегодня и общей статистикой.",
      platformActivity: "Активность платформ (Запланированные посты)",
      cards: { activeProjects: "Активные проекты", todayPosts: "Посты сегодня", published: "Опубликовано", pending: "Ожидаются" },
      upcoming: { title: "Ближайшие посты", empty: "Нет запланированных постов.", todayLabel: "Сегодня" }
    },
    projectList: {
      title: "Панель SMM CRM", archive: "Архив", todayPlan: "План контента на сегодня",
      noToday: "Нет активного контента на сегодня.", activeProjects: "Активные проекты",
      addProject: "Проект", noActive: "Нет активных проектов.",
      actions: { edit: "Редактировать", archive: "В архив" },
      buttons: { cancel: "Отмена", save: "Сохранить", exportPdf: "PDF", addContent: "Контент", restore: "Восстановить", delete: "Удалить" },
      modalTitles: { addProject: "Новый проект", editProject: "Редактирование проекта", addContent: "Добавить контент", editContent: "Редактирование контента" },
      labels: {
        budget: "Бюджет", phone: "Телефон", activeContentCount: "{count} активных публикаций",
        plannedContentList: "Список запланированного контента",
        projectNotSelected: "Проект не выбран или не открыт.",
        archiveTitle: "Архивная база", totalContent: "Всего контента: {count}",
        noActiveContent: "Активного контента нет.", archiveEmptyProjects: "Архив проектов пуст.", archiveEmptyContents: "Архив контента пуст."
      },
      archiveTabs: { projects: "Проекты", contents: "Контент-планы" },
      confirmations: { deleteTitle: "Подтвердите удаление" },
      statuses: { pending: "В ожидании", published: "Опубликовано", cancelled: "Отменено", moved: "Перенесено" },
      formats: { reels: "Reels", carousel: "Карусель", post: "Пост", animation: "Анимация", story: "AI-контент" },
      pdf: { brand: "Бренд:", phone: "Номер:", fullName: "Ф.И.О:", contentPlan: "ПЛАН КОНТЕНТА", date: "Дата:", empty: "Планируемого контента пока нет.", filenameSuffix: "Контент_План" },
      alerts: { fillAll: "Заполните все поля!", titleDateRequired: "Введите заголовок и дату!", selectPlatform: "Выберите хотя бы одну платформу!" },
      placeholders: { projectName: "Название проекта", phone: "Телефон", budget: "Целевой бюджет ($)", contentTitle: "Заголовок", contentIdea: "Идея контента" },
      notifications: {
        projectAdded: 'Проект "{name}" добавлен!', projectEdited: "Проект отредактирован!",
        projectArchived: 'Проект "{name}" архивирован!', projectRestored: "Проект восстановлен из архива!", projectDeleted: "Архивный проект и его контент удалены!", confirmDeleteProject: 'Удалить проект "{name}" и весь его контент навсегда?',
        contentAdded: "Новый контент добавлен!", contentArchived: "Контент архивирован!",
        contentRestored: "Контент восстановлен из архива!", contentDeleted: "Архивный контент-план удалён!", confirmDeleteContent: 'Удалить контент-план "{name}" навсегда?', contentEdited: "Контент отредактирован!",
        statusChanged: "Статус {platform} изменён!", pdfDownloaded: 'PDF "{name}" скачан!'
      }
    },
    login: {
      title: "SMM CRM", subtitle: "Вход в систему", emailPlaceholder: "Введите email",
      passwordPlaceholder: "Пароль", submit: "Войти",
      footer: "Все данные надежно защищены в системе SMM CRM!",
      invalidCredentials: "Email или пароль неверны!"
    },
    analytics: {
      pickBoard: "Выберите доску",
      back: "Назад",
      templates: "Шаблоны",
      archives: "Архивы",
      addCard: "Добавить карточку",
      insertLink: "Добавить ссылку",
      addList: "Добавить список",
      board: "ДОСКА",
      boards: { dizayn: "ДИЗАЙН", montaj: "МОНТАЖ", vfxAi: "VFX & AI" },
      archiveAllCards: "Архивировать все карточки",
      archiveColumn: "Архивировать список",
      columnActions: "Действия со списком",
      changeColumnColor: "Изменить цвет колонки",
      archiveTask: "Архивировать задачу",
      makeTemplate: "Сохранить как шаблон",
      templateListTitle: "Библиотека шаблонов",
      noTemplates: "Шаблонов пока нет",
      newTemplatePlaceholder: "Новый шаблон...",
      createNewTemplate: "+ Создать шаблон",
      cardsTab: "Карточки",
      columnsTab: "Списки",
      noArchiveCards: "Нет архивных карточек",
      noArchiveColumns: "Нет архивных списков",
      restore: "Восстановить",
      column: "Список",
      list: "Список",
      tasksCount: "задач",
      deleteTemplateConfirmTitle: "Удалить шаблон",
      deleteTemplateConfirmMessage: "Вы уверены, что хотите удалить шаблон {name}?",
      cardDeleteConfirmTitle: "Удалить карточку",
      cardDeleteConfirmMessage: "Вы уверены, что хотите удалить эту карточку?",
      columnDeleteConfirmTitle: "Удалить список",
      columnDeleteConfirmMessage: "Вы уверены, что хотите удалить этот список?",
      newColumnPlaceholder: "Название списка...",
      add: "Добавить",
      editColumnHint: "Дважды щелкните, чтобы редактировать",
      labels: { dates: "Даты", participants: "Участники", boardParticipants: "Участники доски", description: "Описание", commentsEvents: "Комментарии и события", archiveTask: "Архивировать карточку" },
      buttons: { save: "Сохранить", cancel: "Отмена", send: "Отправить", confirm: "Подтвердить", delete: "Удалить" },
      tooltips: { doubleClickHint: "Дважды щелкните, чтобы редактировать" },
      toast: {
        columnReordered: "Порядок списка обновлён",
        templateDeleted: "Шаблон удалён",
        cardDeleted: "Карточка удалена",
        columnDeleted: "Список удалён",
        templateSaved: "Шаблон сохранён",
        templateCreated: "Шаблон создан",
        templateApplied: "Шаблон применён",
        templateAppliedHistory: "Добавлено из шаблона",
        columnRestored: "Список восстановлен",
        taskMoved: "Задача перенесена",
        restoreSuccess: "Восстановлено из архива"
      },
      messages: {
        duplicateColumnTitle: "Ошибка",
        duplicateColumnMessage: "Список с таким именем уже существует!",
        newColumnAdded: "Новый список добавлен",
        columnRenamed: "Имя списка изменено",
        newTaskTitle: "Новая задача",
        newTaskPlaceholder: "Введите название задачи...",
        taskAdded: "Новая задача добавлена!",
        taskRenamed: "Имя изменено",
        titleUpdated: "Заголовок обновлён",
        descriptionSaved: "Описание сохранено",
        statusChanged: "Статус изменён",
        membersUpdated: "Участники обновлены",
        deadlineRemoved: "Срок удалён",
        deadlineSaved: "Срок сохранён",
        linkUrlPrompt: "Введите URL ссылки (например: https://google.com):",
        invalidLink: "Введите корректный URL-адрес.",
        archiveCardConfirmTitle: "Архивировать карточку",
        archiveCardConfirmMessage: "Вы действительно хотите архивировать \"{name}\"?",
        archiveColumnConfirmTitle: "Архивировать список",
        archiveColumnConfirmMessage: "Вы хотите архивировать весь список \"{name}\" со всеми задачами?",
        cardArchived: "Задача архивирована",
        noCardsToArchiveTitle: "Внимание",
        noCardsToArchiveMessage: "В этом списке нет карточек для архивации!",
        archiveAllCardsConfirmTitle: "Архивировать все карточки",
        archiveAllCardsConfirmMessage: "Вы хотите архивировать ВСЕ карточки из списка \"{name}\"?",
        allTasksArchived: "Все задачи архивированы",
        deadlineDatePlaceholder: "DD.MM.YYYY",
        deadlineTimePlaceholder: "12:00",
        searchPlaceholder: "Поиск...",
        descriptionPlaceholder: "Добавьте подробное описание...",
        commentPlaceholder: "Напишите комментарий..."
      },
      weekDays: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"]
    },
    boardDetails: { back: "Назад", board: "ДОСКА", addTask: "Добавить задачу", newTaskPrompt: "Введите название задачи:", confirmDeleteTask: "Вы действительно хотите удалить эту задачу?" },
    logout: "Выйти",
    admin: {
      title: "Админ Панель",
      subtitle: "Управляйте пользователями и добавляйте новых",
      addUser: "Новый пользователь",
      addUserSub: "Заполните данные и добавьте",
      userList: "Список пользователей",
      totalUsers: "Всего",
      thisMonth: "В этом месяце",
      name: "Имя Фамилия",
      email: "Email",
      role: "Специализация",
      password: "Пароль",
      pwdPlaceholder: "Введите пароль...",
      randomBtn: "Случайный",
      addBtn: "Добавить",
      selectRole: "Выберите специализацию",
      customRole: "Введите специализацию...",
      addedDate: "Добавлен",
      sendEmail: "Отправить Email",
      viewCredentials: "Просмотр данных",
      deleteUser: "Удалить",
      noUsers: "Пользователи ещё не добавлены",
      noResults: "По запросу ничего не найдено",
      credentialsTitle: "Данные для входа готовы!",
      credentialsSub: "Отправьте эти данные пользователю",
      copy: "Скопировать",
      copied: "Скопировано!",
      closeBtn: "Закрыть",
      deleteTitle: "Удалить пользователя",
      deleteBody: "будет удалён. Вы уверены?",
      cancelBtn: "Отмена",
      deleteBtn: "Удалить",
      fillAll: "Заполните все поля!",
      invalidEmail: "Неверный email адрес!",
      emailExists: "Этот email уже существует!",
      userAdded: "Пользователь добавлен!",
      userDeleted: "Пользователь удалён"
    },
    settings: {
      centerLabel: "Центр настроек",
      title: "Настройки сайта",
      subtitle: "Здесь вы управляете языком, профилем и дизайном сайта.",
      tabs: { language: "Сменить язык", profile: "Профиль", design: "Дизайн сайта", security: "Безопасность" },
      languageTitle: "Сменить язык",
      languageDescription: "Обновите язык интерфейса за несколько секунд.",
      profileTitle: "Профиль",
      profileDescription: "Быстро обновите свои персональные данные.",
      designTitle: "Дизайн сайта",
      designDescription: "Выберите ночной или светлый режим и цвет сайта.",
      securityTitle: "Безопасность",
      securityDescription: "Обновите настройки, чтобы сохранить учетную запись в безопасности.",
      buttons: { save: "Сохранить", themeDark: "Включить темный режим", themeLight: "Включить светлый режим", passwordUpdate: "Обновить пароль", twoFactorOn: "Включить 2FA", twoFactorOff: "Отключить 2FA" },
      colors: { blue: "Синий", purple: "Фиолетовый", green: "Зеленый", orange: "Оранжевый" },
      labels: { fullName: "Полное имя", email: "Email", status: "Статус", currentPassword: "Текущий пароль", newPassword: "Новый пароль", confirmPassword: "Подтвердите пароль", selectedLanguage: "Выбранный язык", accentColor: "Цвет акцента", activeWindow: "Активное окно", currentRules: "Текущие правила" },
      statusActive: { enabled: "2FA включен", disabled: "2FA отключен" },
      activity: { language: "Сделайте общение удобнее с помощью языковых настроек.", profile: "Обновите свои личные данные в разделе профиля.", design: "Измените внешний вид и цвета сайта в разделе дизайна.", security: "Сделайте свой аккаунт более надежным в разделе безопасности." },
      profileCard: "Личный профиль",
      messages: { fillRequired: "Имя и email обязательны для заполнения.", profileSaved: "Данные профиля успешно сохранены.", siteColorChanged: "Основной цвет сайта изменен на {color}.", themeChanged: "Тема переключена в режим {mode}.", passwordRequired: "Заполните все поля пароля.", passwordMismatch: "Новый пароль и подтверждение не совпадают.", passwordShort: "Новый пароль должен содержать минимум 6 символов.", passwordUpdated: "Пароль успешно обновлен.", twoFactorEnabled: "Двухфакторная аутентификация включена.", twoFactorDisabled: "Двухфакторная аутентификация отключена." },
      confirm: { title: "Подтвердить смену языка?", body: "Вы действительно хотите изменить язык сайта? Страница перезагрузится.", yes: "Да", no: "Нет" },
      langTab: "Язык", profileTab: "Данные профиля", designTab: "Дизайн", securityTab: "Безопасность",
      avatarTitle: "Фото профиля", avatarDesc: "JPG, PNG или GIF — макс 5MB", avatarUpload: "Загрузить фото", avatarDelete: "Удалить",
      themeTitle: "Тема", themeLight: "Светлый", themeDark: "Тёмный", themeActive: "Активный", accentTitle: "Основной цвет",
      saveLanguage: "Сохранить язык", saveProfile: "Сохранить данные", cancelBtn: "Отмена", confirmBtn: "Подтвердить",
      langModalTitle: "Подтвердить смену языка?", langModalBody: "Язык сайта изменится на {lang} и страница перезагрузится.",
      pwdPlaceholder: "Минимум 6 символов", pwdStrength: ["Очень слабый", "Слабый", "Средний", "Сильный", "Очень сильный"],
      pwdMatch: "Пароли совпадают", pwdNoMatch: "Пароли не совпадают",
      toastProfileSaved: "Данные профиля сохранены ✓", toastFieldsRequired: "Имя и email не могут быть пустыми!",
      toastPwdRequired: "Заполните все поля пароля!", toastPwdError: "Текущий пароль неверен!",
      toastPwdMismatch: "Новые пароли не совпадают!", toastPwdShort: "Пароль должен содержать минимум 6 символов!",
      toastPwdUpdated: "Пароль успешно обновлён ✓", toastThemeChanged: "Тема изменена ✓", toastColorChanged: "Цвет изменён ✓"
    },
    calendar: {
      title: "Контент Календарь",
      subtitle: "Все планы в одном виде",
      months: ["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],
      weekDays: ["Пн","Вт","Ср","Чт","Пт","Сб","Вс"],
      today: "Сегодня",
      noPostsDay: "Нет контента на этот день",
      moreItems: "+{n} ещё",
      postsFor: "План контента",
      totalThisMonth: "Всего в месяце",
      publishedThisMonth: "Опубликовано"
    },
    search: {
      placeholder: "Поиск: проект, контент, карточка...",
      noResults: "Ничего не найдено",
      typing: "Начните вводить для поиска...",
      projects: "Проекты",
      contents: "Контент",
      cards: "Карточки"
    }
  },
  "English": {
    menu: { dashboard: "Dashboard", projects: "Projects", analytics: "Boards", calendar: "Calendar", admin: "Admin Panel", contact: "Contact Us", settings: "Settings", search: "Search" },
    dashboard: {
      welcome: "Welcome, SMM Manager!",
      subtitle: "See today's plan and overall stats.",
      platformActivity: "Platform Activity (Scheduled Posts)",
      cards: { activeProjects: "Active Projects", todayPosts: "Today's Posts", published: "Published", pending: "Pending" },
      upcoming: { title: "Upcoming posts", empty: "No upcoming posts scheduled.", todayLabel: "Today" }
    },
    projectList: {
      title: "SMM CRM Panel", archive: "Archive", todayPlan: "Today's content plan",
      noToday: "No active content for today.", activeProjects: "Active Projects",
      addProject: "Project", noActive: "No active projects yet.",
      actions: { edit: "Edit", archive: "Archive" },
      buttons: { cancel: "Cancel", save: "Save", exportPdf: "PDF", addContent: "Content", restore: "Restore", delete: "Delete" },
      modalTitles: { addProject: "New project", editProject: "Edit project", addContent: "Add content", editContent: "Edit content" },
      labels: {
        budget: "Budget", phone: "Phone", activeContentCount: "{count} active pieces of content",
        plannedContentList: "Planned content list",
        projectNotSelected: "No project selected or opened.",
        archiveTitle: "Archive base", totalContent: "Total content: {count}",
        noActiveContent: "No active content.", archiveEmptyProjects: "Project archive is empty.", archiveEmptyContents: "Content archive is empty."
      },
      archiveTabs: { projects: "Projects", contents: "Content plans" },
      confirmations: { deleteTitle: "Confirm deletion" },
      statuses: { pending: "Pending", published: "Published", cancelled: "Cancelled", moved: "Moved" },
      formats: { reels: "Reels", carousel: "Carousel", post: "Post", animation: "Animation", story: "AI content" },
      pdf: { brand: "Brand:", phone: "Phone:", fullName: "Full name:", contentPlan: "CONTENT PLAN", date: "Date:", empty: "No planned content available yet.", filenameSuffix: "Content_Plan" },
      alerts: { fillAll: "Please complete all fields!", titleDateRequired: "Enter title and date!", selectPlatform: "Select at least one platform!" },
      placeholders: { projectName: "Project name", phone: "Phone number", budget: "Target budget ($)", contentTitle: "Title", contentIdea: "Content idea" },
      notifications: {
        projectAdded: '"{name}" project added!', projectEdited: "Project edited!",
        projectArchived: '"{name}" archived!', projectRestored: "Project restored from archive!", projectDeleted: "Archived project and its content deleted!", confirmDeleteProject: 'Permanently delete project "{name}" and all its content?',
        contentAdded: "New content added!", contentArchived: "Content archived!",
        contentRestored: "Content restored from archive!", contentDeleted: "Archived content plan deleted!", confirmDeleteContent: 'Permanently delete the content plan "{name}"?', contentEdited: "Content edited!",
        statusChanged: "{platform} status changed!", pdfDownloaded: '"{name}" PDF downloaded!'
      }
    },
    login: {
      title: "SMM CRM", subtitle: "Sign in to your account", emailPlaceholder: "Enter email",
      passwordPlaceholder: "Password", submit: "Sign in",
      footer: "All data is securely protected by the SMM CRM system!",
      invalidCredentials: "Email or password is incorrect!"
    },
    analytics: {
      pickBoard: "Pick a board",
      back: "Back",
      templates: "Templates",
      archives: "Archives",
      addCard: "Add card",
      insertLink: "Add link",
      addList: "Add list",
      board: "BOARD",
      boards: { dizayn: "DESIGN", montaj: "EDITING", vfxAi: "VFX & AI" },
      archiveAllCards: "Archive all cards",
      archiveColumn: "Archive list",
      columnActions: "List actions",
      changeColumnColor: "Change list color",
      archiveTask: "Archive task",
      makeTemplate: "Save as template",
      templateListTitle: "Template library",
      noTemplates: "No templates yet",
      newTemplatePlaceholder: "New template...",
      createNewTemplate: "+ Create template",
      cardsTab: "Cards",
      columnsTab: "Lists",
      noArchiveCards: "No archived cards",
      noArchiveColumns: "No archived lists",
      restore: "Restore",
      column: "List",
      list: "List",
      tasksCount: "tasks",
      deleteTemplateConfirmTitle: "Delete template",
      deleteTemplateConfirmMessage: "Are you sure you want to delete the template {name}?",
      cardDeleteConfirmTitle: "Delete card",
      cardDeleteConfirmMessage: "Are you sure you want to delete this card?",
      columnDeleteConfirmTitle: "Delete list",
      columnDeleteConfirmMessage: "Are you sure you want to delete this list?",
      newColumnPlaceholder: "New list name...",
      add: "Add",
      editColumnHint: "Double-click to edit",
      labels: { dates: "Dates", participants: "Participants", boardParticipants: "Board participants", description: "Description", commentsEvents: "Comments & events", archiveTask: "Archive task" },
      buttons: { save: "Save", cancel: "Cancel", send: "Send", confirm: "Confirm", delete: "Delete" },
      tooltips: { doubleClickHint: "Double-click to edit" },
      toast: {
        columnReordered: "List order updated",
        templateDeleted: "Template deleted",
        cardDeleted: "Card deleted",
        columnDeleted: "List deleted",
        templateSaved: "Template saved",
        templateCreated: "Template created",
        templateApplied: "Template applied",
        templateAppliedHistory: "Added from template",
        columnRestored: "List restored",
        taskMoved: "Task moved",
        restoreSuccess: "Restored from archive"
      },
      messages: {
        duplicateColumnTitle: "Error",
        duplicateColumnMessage: "A column with this name already exists!",
        newColumnAdded: "New list added",
        columnRenamed: "Column renamed",
        newTaskTitle: "New task",
        newTaskPlaceholder: "Enter task name...",
        taskAdded: "New task added!",
        taskRenamed: "Name updated",
        titleUpdated: "Title updated",
        descriptionSaved: "Description saved",
        statusChanged: "Status changed",
        membersUpdated: "Members updated",
        deadlineRemoved: "Deadline removed",
        deadlineSaved: "Deadline saved",
        linkUrlPrompt: "Enter link URL (e.g. https://google.com):",
        invalidLink: "Enter a valid URL.",
        archiveCardConfirmTitle: "Archive task",
        archiveCardConfirmMessage: "Are you sure you want to archive \"{name}\"?",
        archiveColumnConfirmTitle: "Archive list",
        archiveColumnConfirmMessage: "Do you want to archive the entire \"{name}\" list with all tasks?",
        cardArchived: "Task archived",
        noCardsToArchiveTitle: "Attention",
        noCardsToArchiveMessage: "There are no cards to archive in this list!",
        archiveAllCardsConfirmTitle: "Archive all cards",
        archiveAllCardsConfirmMessage: "Do you want to archive ALL cards from the \"{name}\" list?",
        allTasksArchived: "All tasks archived",
        deadlineDatePlaceholder: "DD.MM.YYYY",
        deadlineTimePlaceholder: "12:00",
        searchPlaceholder: "Search...",
        descriptionPlaceholder: "Add detailed description...",
        commentPlaceholder: "Write a comment..."
      },
      weekDays: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"]
    },
    boardDetails: { back: "Back", board: "BOARD", addTask: "Add task", newTaskPrompt: "Enter task name:", confirmDeleteTask: "Are you sure you want to delete this task?" },
    logout: "Logout",
    admin: {
      title: "Admin Panel",
      subtitle: "Manage users and add new ones",
      addUser: "New User",
      addUserSub: "Fill in the details and add",
      userList: "User List",
      totalUsers: "Total",
      thisMonth: "This month",
      name: "Full Name",
      email: "Email",
      role: "Specialization",
      password: "Password",
      pwdPlaceholder: "Enter password...",
      randomBtn: "Random",
      addBtn: "Add",
      selectRole: "Select specialization",
      customRole: "Enter custom specialization...",
      addedDate: "Added",
      sendEmail: "Send Email",
      viewCredentials: "View credentials",
      deleteUser: "Delete",
      noUsers: "No users added yet",
      noResults: "No results found",
      credentialsTitle: "Login credentials ready!",
      credentialsSub: "Send these credentials to the user",
      copy: "Copy",
      copied: "Copied!",
      closeBtn: "Close",
      deleteTitle: "Delete User",
      deleteBody: "will be deleted. Are you sure?",
      cancelBtn: "Cancel",
      deleteBtn: "Delete",
      fillAll: "Please fill in all fields!",
      invalidEmail: "Invalid email address!",
      emailExists: "This email already exists!",
      userAdded: "User added successfully!",
      userDeleted: "User deleted"
    },
    settings: {
      centerLabel: "Settings Center",
      title: "Site Settings",
      subtitle: "Manage site language, profile and design here.",
      tabs: { language: "Change language", profile: "Profile", design: "Site design", security: "Security" },
      languageTitle: "Change language",
      languageDescription: "Update the interface language in seconds.",
      profileTitle: "Profile",
      profileDescription: "Quickly update your personal details.",
      designTitle: "Site design",
      designDescription: "Choose dark or light mode and site accent colors.",
      securityTitle: "Security",
      securityDescription: "Update settings to keep your account secure.",
      buttons: { save: "Save", themeDark: "Switch to dark mode", themeLight: "Switch to light mode", passwordUpdate: "Update password", twoFactorOn: "Enable 2FA", twoFactorOff: "Disable 2FA" },
      colors: { blue: "Blue", purple: "Purple", green: "Green", orange: "Orange" },
      labels: { fullName: "Full Name", email: "Email", status: "Status", currentPassword: "Current Password", newPassword: "New Password", confirmPassword: "Confirm Password", selectedLanguage: "Selected Language", accentColor: "Accent Color", activeWindow: "Active Window", currentRules: "Current Rules" },
      statusActive: { enabled: "2FA enabled", disabled: "2FA disabled" },
      activity: { language: "Make communication easier with language settings.", profile: "Update your personal details in the profile section.", design: "Adjust site appearance and colors in the design section.", security: "Make your account more secure in the security section." },
      profileCard: "Personal profile",
      messages: { fillRequired: "Name and email are required.", profileSaved: "Profile details saved successfully.", siteColorChanged: "Site primary color changed to {color}.", themeChanged: "Theme switched to {mode} mode.", passwordRequired: "Fill in all password fields.", passwordMismatch: "New password and confirmation do not match.", passwordShort: "New password must be at least 6 characters.", passwordUpdated: "Password updated successfully.", twoFactorEnabled: "Two-factor authentication enabled.", twoFactorDisabled: "Two-factor authentication disabled." },
      confirm: { title: "Confirm language change?", body: "Do you want to change the site language? The site will reload.", yes: "Yes", no: "No" },
      langTab: "Language", profileTab: "Profile data", designTab: "Design", securityTab: "Security",
      avatarTitle: "Profile picture", avatarDesc: "JPG, PNG or GIF — max 5MB", avatarUpload: "Upload image", avatarDelete: "Delete",
      themeTitle: "Theme", themeLight: "Light", themeDark: "Dark", themeActive: "Active", accentTitle: "Accent color",
      saveLanguage: "Save language", saveProfile: "Save data", cancelBtn: "Cancel", confirmBtn: "Confirm",
      langModalTitle: "Confirm language change?", langModalBody: "The site language will change to {lang} and the page will reload.",
      pwdPlaceholder: "At least 6 characters", pwdStrength: ["Very weak", "Weak", "Medium", "Strong", "Very strong"],
      pwdMatch: "Passwords match", pwdNoMatch: "Passwords don't match",
      toastProfileSaved: "Profile data saved ✓", toastFieldsRequired: "Name and email cannot be empty!",
      toastPwdRequired: "Fill in all password fields!", toastPwdError: "Current password is incorrect!",
      toastPwdMismatch: "New passwords don't match!", toastPwdShort: "Password must be at least 6 characters!",
      toastPwdUpdated: "Password updated successfully ✓", toastThemeChanged: "Theme changed ✓", toastColorChanged: "Color changed ✓"
    },
    calendar: {
      title: "Content Calendar",
      subtitle: "All plans in one view",
      months: ["January","February","March","April","May","June","July","August","September","October","November","December"],
      weekDays: ["Mo","Tu","We","Th","Fr","Sa","Su"],
      today: "Today",
      noPostsDay: "No content for this day",
      moreItems: "+{n} more",
      postsFor: "Content plan",
      totalThisMonth: "Total this month",
      publishedThisMonth: "Published"
    },
    search: {
      placeholder: "Search: project, content, card...",
      noResults: "Nothing found",
      typing: "Start typing to search...",
      projects: "Projects",
      contents: "Content",
      cards: "Cards"
    }
  }
};

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    try {
      const saved = localStorage.getItem('smm_crm_language');
      return saved ? JSON.parse(saved) : "O'zbekcha";
    } catch {
      return "O'zbekcha";
    }
  });

  useEffect(() => {
    try { localStorage.setItem('smm_crm_language', JSON.stringify(language)); } catch {}
  }, [language]);

  const t = (path) => {
    const parts = path.split('.');
    let node = translations[language] || translations["O'zbekcha"];
    for (const p of parts) {
      if (node == null) return path;
      node = node[p];
    }
    return node ?? path;
  };

  return (
    <I18nContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
